import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./estruturas.component.html')
})
export class EstruturasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/estruturas.component.ts
 **/